import { Box } from "@mui/material";

const SvgYT = (props) => {
    return (
        <svg
            stroke="black"
            fill="black"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height={props.size}
            width={props.size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fillRule="evenodd" d="M9.522,15.553 L9.52125,8.80975 L16.00575,12.193 L9.522,15.553 Z M23.76,7.64125 C23.76,7.64125 23.52525,5.9875 22.806,5.25925 C21.89325,4.303 20.87025,4.2985 20.4015,4.243 C17.043,4 12.00525,4 12.00525,4 L11.99475,4 C11.99475,4 6.957,4 3.5985,4.243 C3.129,4.2985 2.10675,4.303 1.19325,5.25925 C0.474,5.9875 0.24,7.64125 0.24,7.64125 C0.24,7.64125 0,9.58375 0,11.5255 L0,13.3465 C0,15.289 0.24,17.23075 0.24,17.23075 C0.24,17.23075 0.474,18.8845 1.19325,19.61275 C2.10675,20.569 3.306,20.539 3.84,20.63875 C5.76,20.82325 12,20.88025 12,20.88025 C12,20.88025 17.043,20.87275 20.4015,20.62975 C20.87025,20.5735 21.89325,20.569 22.806,19.61275 C23.52525,18.8845 23.76,17.23075 23.76,17.23075 C23.76,17.23075 24,15.289 24,13.3465 L24,11.5255 C24,9.58375 23.76,7.64125 23.76,7.64125 L23.76,7.64125 Z"></path>
        </svg>
    );
};

const SvgX = (props) => {
    return (
        <svg
            stroke="currentColor"
            fill="var(--background-color)"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height={props.size} 
            width={props.size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
        </svg>
    );
};

const SocialBox = (props) => {
    const imgScale = props.scale ?? '80%';
    return (
        <Box 
            className="opacityHover"
            sx={{
                backgroundColor: props.color,
                height: '100%',
                width: '25%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <a 
                href={props.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {props.src === '/images/yt.png' ? (
                    <SvgYT size={imgScale} />
                ) : props.src === '/images/x.png' ? (
                    <SvgX size={imgScale} />
                ) : (
                    <img 
                        src={props.src} 
                        alt={props.alt} 
                        style={{ width: imgScale, height: imgScale }} 
                    />
                )}
            </a>
        </Box>
    );
};

export default SocialBox;